import { useQuery } from "@tanstack/react-query";
import { getExtractionsSummary } from "../api/extractions";
import type { ExtractionSummaryRow } from "../types";

export function useExtractionsSummary(projectId: string | undefined, enabled = true) {
  return useQuery<ExtractionSummaryRow[]>({
    queryKey: ["extractions", projectId, "summary"],
    queryFn: () => getExtractionsSummary(projectId!),
    enabled: !!projectId && enabled,
    staleTime: 10_000,
  });
}
